import { useRef, useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { useLocation } from 'react-router-dom'

const EXCLUDED_PREFIXES = ['/game/', '/race/', '/spectator/', '/solo/']
const CHECK_COOLDOWN_MS = 60 * 60 * 1000
const LAST_CHECK_KEY = 'pwa_last_update_check'

export default function UpdateNotifier() {
  const location = useLocation()
  const regRef = useRef(null)

  const { needRefresh: [needRefresh], updateServiceWorker } = useRegisterSW({
    onRegisteredSW(_url, r) {
      if (r) regRef.current = r
    }
  })

  useEffect(() => {
    if (location.pathname !== '/home') return
    const r = regRef.current
    if (!r || r.installing) return
    const lastCheck = parseInt(localStorage.getItem(LAST_CHECK_KEY) || '0', 10)
    if (Date.now() - lastCheck < CHECK_COOLDOWN_MS) return
    localStorage.setItem(LAST_CHECK_KEY, String(Date.now()))
    try { r.update() } catch {}
  }, [location.pathname])

  if (!needRefresh) return null
  if (EXCLUDED_PREFIXES.some(p => location.pathname.startsWith(p))) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 flex items-center justify-between gap-3 rounded-xl bg-primary px-4 py-3 text-white shadow-lg">
      <span className="text-sm font-medium">Nouvelle version disponible</span>
      <button
        onClick={async () => {
          await updateServiceWorker(true)
          window.location.reload()
        }}
        className="shrink-0 rounded-lg bg-white px-3 py-1.5 text-sm font-semibold text-primary transition duration-150 hover:bg-blue-50 active:scale-95"
      >
        Mettre à jour
      </button>
    </div>
  )
}
